
export const blockKeys = (blockedKeys: string[]) => {
  return (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (blockedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };
};
